import projects1 from './projects1.jsx';
import projects2 from './projects2.jsx';

export default [...projects2, ...projects1];
